import { ITokenModel } from '../token/interface';
import { IStore } from './interface';

export function STORE_TOKEN_LOCAL_FACTORY(): IStore {
  return new LocalStorageStore();
}

export class LocalStorageStore implements IStore {
  /**
  * LocalStorageからトークン情報を取得する（ITokenModelに変換）
  */
  get(key: string): ITokenModel {
    return JSON.parse(localStorage.getItem(key) || '{}') || {};
  }
  /**
   * LocalStorage中のトークン情報を更新する（Json文字列）
   */
  set(key: string, value: ITokenModel | null): boolean {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  }
  /**
   * LocalStorage中のトークン情報をクリアする
   */
  remove(key: string): void {
    localStorage.removeItem(key);
  }
}